module.exports = __webpack_public_path__ + "img/digital_card_bohinj_footer_winter.9095ac5e.png";